import SchoolsService from './Schools.service';
import MenusService from './Menus.service';
import SystemRepository from './SystemRepository';
import NotificationService from './Notification.service';
import ResearchService from './Research.service';
import ProvinceService from './Province.service';
import StorageService from './Storage.service';
import VersionService from "@/services/Version.service";

const storage = new StorageService();
const services = {
  'notification': NotificationService,
  'schools': new SchoolsService(storage),
  'menus': MenusService,
  'system': SystemRepository,
  'researches': ResearchService,
  'province': ProvinceService,
  'storage': storage,
  'version': new VersionService(storage)
  // ... others services/repositories
};

export default {
  get: name => services[name]
}
